import {
    SET_ISLOGGEDIN_ACTION,
    STEP_REDIRECT_ACTION,
    VALIDATE_ACTION,
    SET_REFERRAL,
    SET_PREVIEWDATA
} from './constants'

export const validationAction = (payload) => ({
    type: VALIDATE_ACTION,
    payload: payload
})

export const setIsLoggedInAction = (payload) => ({
    type: SET_ISLOGGEDIN_ACTION,
    payload: payload
})

export const setStepRedirectAction = (payload) => ({
    type: STEP_REDIRECT_ACTION,
    payload: payload
})

export const setReferral = (payload) => ({
    type: SET_REFERRAL,
    payload: payload
})
export const setPreviewData = (payload) => ({
    type: SET_PREVIEWDATA,
    payload: payload
})


// WEBPACK FOOTER //
// ./src/conteiners/Callback/accions.js